import { VideoHistoryTypes } from './types';

const initialState = {
  videos: [],
  loading: {
    fetchHistory: false,
    addVideo: false,
    updateProgress: false,
    historyPlayback: false
  },
  error: {
    fetchHistory: null,
    addVideo: null,
    updateProgress: null,
    historyPlayback: null
  },
  player: {
    videos: [],
    currentVideoIndex: 0,
    autoplayEnabled: true,
    isPlaying: false
  },
  viewMode: 'grid' // 'grid' or 'column'
};

export const videoHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch video history
    case VideoHistoryTypes.FETCH_VIDEO_HISTORY_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchHistory: true
        },
        error: {
          ...state.error,
          fetchHistory: null
        }
      };
      
    case VideoHistoryTypes.FETCH_VIDEO_HISTORY_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchHistory: false
        },
        // Ensure we always have a valid videos array even if the payload is malformed
        videos: action.payload?.videos || [],
        // Clear any previous error state
        error: {
          ...state.error,
          fetchHistory: null
        }
      };
      
    case VideoHistoryTypes.FETCH_VIDEO_HISTORY_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchHistory: false
        },
        error: {
          ...state.error,
          fetchHistory: action.payload
        },
        // Keep videos as-is, don't reset to avoid flashing content
        // videos: state.videos || []
      };
      
    // Add to video history
    case VideoHistoryTypes.ADD_TO_VIDEO_HISTORY_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          addVideo: true
        },
        error: {
          ...state.error,
          addVideo: null
        }
      };
      
    case VideoHistoryTypes.ADD_TO_VIDEO_HISTORY_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          addVideo: false
        },
        videos: action.payload.videos || state.videos
      };
      
    case VideoHistoryTypes.ADD_TO_VIDEO_HISTORY_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          addVideo: false
        },
        error: {
          ...state.error,
          addVideo: action.payload
        }
      };
      
    // Update video progress
    case VideoHistoryTypes.UPDATE_VIDEO_PROGRESS_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateProgress: true
        },
        error: {
          ...state.error,
          updateProgress: null
        }
      };
      
    case VideoHistoryTypes.UPDATE_VIDEO_PROGRESS_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateProgress: false
        },
        videos: action.payload.videos || state.videos
      };
      
    case VideoHistoryTypes.UPDATE_VIDEO_PROGRESS_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateProgress: false
        },
        error: {
          ...state.error,
          updateProgress: action.payload
        }
      };
      
    // Mark video as completed
    case VideoHistoryTypes.MARK_VIDEO_COMPLETED_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateProgress: true
        }
      };
      
    case VideoHistoryTypes.MARK_VIDEO_COMPLETED_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateProgress: false
        },
        videos: action.payload.videos || state.videos
      };
      
    case VideoHistoryTypes.MARK_VIDEO_COMPLETED_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateProgress: false
        },
        error: {
          ...state.error,
          updateProgress: action.payload
        }
      };
      
    // Playback controls
    case VideoHistoryTypes.LOAD_HISTORY_FOR_PLAYBACK_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          historyPlayback: true
        },
        error: {
          ...state.error,
          historyPlayback: null
        }
      };
      
    case VideoHistoryTypes.LOAD_HISTORY_FOR_PLAYBACK_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          historyPlayback: false
        },
        player: {
          ...state.player,
          videos: action.payload.videos || [],
          currentVideoIndex: action.payload.startIndex || 0,
          isPlaying: true
        },
        error: {
          ...state.error,
          historyPlayback: null
        }
      };
      
    case VideoHistoryTypes.LOAD_HISTORY_FOR_PLAYBACK_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          historyPlayback: false
        },
        error: {
          ...state.error,
          historyPlayback: action.payload
        }
      };
      
    case VideoHistoryTypes.SET_HISTORY_PLAYBACK_INDEX:
      return {
        ...state,
        player: {
          ...state.player,
          currentVideoIndex: action.payload
        }
      };
      
    case VideoHistoryTypes.NEXT_HISTORY_VIDEO:
      return {
        ...state,
        player: {
          ...state.player,
          currentVideoIndex: Math.min(
            state.player.currentVideoIndex + 1, 
            state.player.videos.length - 1
          )
        }
      };
      
    case VideoHistoryTypes.PREVIOUS_HISTORY_VIDEO:
      return {
        ...state,
        player: {
          ...state.player,
          currentVideoIndex: Math.max(state.player.currentVideoIndex - 1, 0)
        }
      };
      
    case VideoHistoryTypes.TOGGLE_HISTORY_AUTOPLAY:
      return {
        ...state,
        player: {
          ...state.player,
          autoplayEnabled: !state.player.autoplayEnabled
        }
      };
      
    case VideoHistoryTypes.SET_HISTORY_VIEW_MODE:
      return {
        ...state,
        viewMode: action.payload
      };
      
    case VideoHistoryTypes.CLEAR_HISTORY_PLAYBACK:
      return {
        ...state,
        player: {
          ...initialState.player
        }
      };
      
    default:
      return state;
  }
};

export default videoHistoryReducer;
